import { generatePath } from 'react-router-dom';
import { routePaths } from 'router';
import type { TAuditLogEntityType } from 'api/swagger';
import type { IAuditEntityReference } from 'components/common/audit-logs/types.ts';
import type { IAuditEntityRoute } from './types';

const AUDIT_ENTITY_ROUTES: Partial<Record<TAuditLogEntityType, IAuditEntityRoute>> = {
  cargo: { path: routePaths.cargo, param: 'cargoId' },
  client: { path: routePaths.client, param: 'clientId' },
  expense: { path: routePaths.expense, param: 'expenseId' },
  invoice: { path: routePaths.invoice, param: 'invoiceId' },
  order: { path: routePaths.order, param: 'orderId' },
  trip: { path: routePaths.trip, param: 'tripId' },
};

export const getAuditEntityPath = (reference: IAuditEntityReference) => {
  const route = AUDIT_ENTITY_ROUTES[reference.entityType];

  if (!route) return null;

  return generatePath(route.path, {
    [route.param]: String(reference.entityId),
  });
};
